import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ORGANIZATIONS_FEATURE_KEY, OrganizationsState, organizationsAdapter } from './organizations.reducer';

export const selectOrganizationsState = createFeatureSelector<OrganizationsState>(ORGANIZATIONS_FEATURE_KEY);

export const {
    selectAll: selectAllOrganizations,
    selectEntities: selectOrganizationEntities,
    selectIds: selectOrganizationIds,
    selectTotal: selectTotalOrganizations
} = organizationsAdapter.getSelectors(selectOrganizationsState);

export const getSelectedOrganizationId = createSelector(
    selectOrganizationsState,
    (state) => state.selectedOrganizationId
);

export const getSelectedOrganization = createSelector(
    selectOrganizationEntities,
    getSelectedOrganizationId,
    (entities, selectedId) => (selectedId ? entities[selectedId] || null : null)
);

export const organizationsLoading = createSelector(selectOrganizationsState, (state) => state.loading);

export const getOrganizationById = (id: number) =>
    createSelector(selectOrganizationEntities, (entities) => entities[id] || null);

export const getOrganizationsByIds = (ids: number[]) =>
    createSelector(selectAllOrganizations, (organizations) => organizations.filter((org) => ids.includes(org.id)));
